import { render, staticRenderFns } from "./PositionDialog.vue?vue&type=template&id=1f7a649a"
import script from "./PositionDialog.vue?vue&type=script&lang=ts"
export * from "./PositionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports